import { StorageKey } from "../constants/StorageKey";
import type { LoginResponse } from "../models/LoginResponse";

class AuthStorage {
  getSession(): LoginResponse | undefined {
    const storedValue = localStorage.getItem(StorageKey.AuthenticationSession);

    if (!storedValue) {
      return undefined;
    }

    try {
      return JSON.parse(storedValue) as LoginResponse;
    } catch {
      this.clearSession();
      return undefined;
    }
  }

  setSession(session: LoginResponse): void {
    localStorage.setItem(
      StorageKey.AuthenticationSession,
      JSON.stringify(session),
    );
  }

  clearSession(): void {
    localStorage.removeItem(StorageKey.AuthenticationSession);
  }

  getToken(): string | undefined {
    return this.getSession()?.Token;
  }

  hasSession(): boolean {
    return Boolean(this.getToken());
  }
}

export const authStorage = new AuthStorage();
